import React from "react";
import "swiper/dist/css/swiper.min.css";
import "../../pages/index.styl";
import LoadingOverlay from "react-loading-overlay";
import { SinglePreventCloseAccordion } from "../Accordion";
import contactLocations from "../../contactLocations";
import 'isomorphic-fetch'

class ContactForm extends React.Component {
  state = {
    firstname: "",
    lastname: "",
    email: "",
    tel: "",
    company: "",
    message: "",
    success: false,
    overlayText: "Sending...",
    overlaySpinner: true,
    source: this.props.source
  };

  handleUpdate = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = event => {
    event.preventDefault();
    {document.getElementById("contact-form-fs").disabled = true};
    {document.getElementById("sendbtn").disabled = true};
    {document.getElementById("sendbtn").setAttribute("style", "background: #cd626d")};
    this.setState({
      isActive: true,
      overlayText: "Sending...",
      overlaySpinner: true
    });
    //alert(JSON.stringify(this.state));

    this.postData("/email/postEmailer.php") //.then(data => console.log(JSON.stringify(data)))

      .then(data => {
        this.setState({
          overlayText: "Sent!",
          overlaySpinner: false,
        });
      });

    setTimeout(() => {
      this.setState({ isActive: false });
      document.getElementById("contact-form").reset();
      document.getElementById("contact-form-fs").disabled = false;
      document.getElementById("sendbtn").disabled = false;
      {document.getElementById("sendbtn").setAttribute("style", "")};
    }, 3000);
  };

  postData = url => {
    // Default options are marked with *
    return fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      //cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"

        //"Content-Type": "text/html",
        //"Accept" : "text/html"//,
        //  "Accept-Encoding": "gzip, deflate"
        // "Content-Type": "application/x-www-form-urlencoded",
      },
      body:
        "firstName=" +
        this.state.firstname +
        "&lastName=" +
        this.state.lastname +
        "&email=" +
        this.state.email +
        "&tel=" +
        this.state.tel +
        "&company=" +
        this.state.company +
        "&message=" +
        this.state.message
    }).then(response => response.text()); //.json()); // parses response to JSON
  };

  render() {
    return (
      <div className="contact-form-section__content o-column-container">
        <div className="contact-form-section__left">
          <h2 className="contact-form-section__title t-h1">Contact Us</h2>
          <SinglePreventCloseAccordion items={contactLocations} />
        </div>
        <div className="contact-form-section__right">
          <h2 className="contact-form-section__title t-h1">Say Hello</h2>
            <form
              id="contact-form"
              className="contact-form-section__form"
              onSubmit={event => {
                this.handleSubmit(event);
              }}
              onChange={event => {
                this.handleUpdate(event);
              }}
            >
              <fieldset id="contact-form-fs" className="contact-form-section__fieldset">
              <input
                id="firstname"
                name="firstname"
                type="text"
                placeholder="*First Name"
                required
                className="contact-form-section__field contact-form-section__field--50 c-input"
              />
              <input
                id="lastname"
                name="lastname"
                type="text"
                placeholder="*Last Name"
                required
                className="contact-form-section__field contact-form-section__field--50 c-input"
              />
              <input
                id="email"
                name="email"
                type="email"
                placeholder="*Email Address"
                required
                className="contact-form-section__field contact-form-section__field--50 c-input"
              />
              <input
                id="tel"
                name="tel"
                type="tel"
                placeholder="Phone Number"
                className="contact-form-section__field contact-form-section__field--50 c-input"
              />
              <input
                id="company"
                name="company"
                type="text"
                placeholder="Company (if applicable)"
                className="contact-form-section__field contact-form-section__field--100 c-input"
              />
              <textarea
                id="message"
                name="message"
                placeholder="*Your Message…"
                required
                className="contact-form-section__field contact-form-section__field--100 contact-form-section__textarea c-input"
              />
              </fieldset>
            <div className="contact-form-section__field">
              <LoadingOverlay
            active={this.state.isActive}
            spinner={false}
            text={this.state.overlayText}
            classNamePrefix={this.state.source}
            styles={{
              overlay: (base) => ({
                ...base,
                background: 'rgba(0, 0, 0, 0)'
              })
            }}
          >     
                <button id="sendbtn" type="submit" className="c-btn t-link">
                  Send Message
                </button>
          </LoadingOverlay>
              </div>
            </form>
        </div>
      </div>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/Forms/ContactForm.js